
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 151 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.96 0h147a2 2 0 012 2 2 2 0 01-2 2h-147a2 2 0 01-2-2 2 2 0 012-2zM19.96 12h117a2 2 0 012 2 2 2 0 01-2 2h-117a2 2 0 01-2-2 2 2 0 012-2zM1.96 24h147a2 2 0 012 2 2 2 0 01-2 2h-147a2 2 0 01-2-2 2 2 0 012-2zM19.96 36h117a2 2 0 012 2 2 2 0 01-2 2h-117a2 2 0 01-2-2 2 2 0 012-2z","fill":"#ededed"}})])
          )
        }
      }
    